// extracted by mini-css-extract-plugin
export default {"container":"EntityCardContent_container__sVxv3"};